import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrBJ: CultureInfo = {
  name: 'fr-BJ',
  displayName: 'français (Bénin)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-BJ',
  parent: CultureInfoFr
};
